import React from 'react';
import PropTypes from 'prop-types';

import cn from 'classnames';

import { Button, SVGIcon } from 'react-md';
import { map } from 'lodash-es';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';

import { ActionButtonEnum } from './ButtonAction.enum';

import './ButtonAction.scss';

/**
 * Button Action
 * @param {*} param0
 */
const ButtonAction = ({ typeAction, disabled, action, label, className }) => {
  let icon;

  switch (typeAction) {
    case ActionButtonEnum.ADD:
      icon = faPlus.icon;
      break;
    case ActionButtonEnum.REMOVE:
      icon = faMinus.icon;
      break;
    default:
      break;
  }

  const iconSVG = (
    <SVGIcon size={20} viewBox={`0 0 ${icon[0]} ${icon[1]}`}>
      <path d={icon[4]} />
    </SVGIcon>
  );

  return (
    <Button
      raised
      disabled={disabled}
      className={cn('btn_action', className, {
        button_add: typeAction === ActionButtonEnum.ADD,
        button_remove: typeAction === ActionButtonEnum.REMOVE,
      })}
      type="button"
      onClick={action}
      iconEl={iconSVG}
    >
      {label}
    </Button>
  );
};

ButtonAction.propTypes = {
  typeAction: PropTypes.oneOf(map(ActionButtonEnum, item => item)).isRequired,
  action: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  className: PropTypes.string,
};
ButtonAction.defaultProps = {
  disabled: false,
  label: '',
  className: '',
};

export default ButtonAction;
